import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F98989F8-DE11-42A7-A814-5C988CBD7989
 * name music-note-sixteenth-dotted
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-sixteenth-dotted.svg
 * tags
 * - Music 
 */
export const MusicNoteSixteenthDottedIcon = createSvgIcon(<><path d="M18 18.5A1.5 1.5 0 1 1 16.5 17A1.5 1.5 0 0 1 18 18.5M18 7V3H12V13.55A4 4 0 1 0 14 17V11H18V8H14V7Z" /></>, 'MusicNoteSixteenthDottedIcon');
export default MusicNoteSixteenthDottedIcon